import { UserProfileLogoutSuccessResponseData } from '../types';
import { useDataMutation } from '@packages/dataQuery';
import { userLogout } from '../api';
import { NetworkError } from '@packages/dataFetch';

export const useUserProfileLogoutMutation = () => {
	return useDataMutation<UserProfileLogoutSuccessResponseData, NetworkError>(userLogout, {
		onSuccess: (data) => {
			window.location.href = data.redirect;
		},
	});
};
